<div class="monitoring-container">
    <app-ops-alarm-topbar-xsmall
        [title]="pageTitle"
        [hidden]="!responsive.isXSmall()"
        (onBackEmit)="onBack()"
    >
    </app-ops-alarm-topbar-xsmall>
    <div
        class="table"
        #dynamicMaxHeight="appDynamicMaxHeight"
        appDynamicMaxHeight
        [ngClass]="{ 'table-no-height-limit': removeHeightLimits }"
    >
        <app-alarm-table-header
            #tHeader
            [hidden]="!responsive.isXLarge()"
            [showRefresh]="false"
        ></app-alarm-table-header>
        <app-alarm-table-header-compact
            #tHeaderCompact
            [hidden]="responsive.isXLarge()"
            [showRefresh]="false"
        ></app-alarm-table-header-compact>

        <div class="main-content" #mainContent (scroll)="onScroll()">
            <app-ops-table-body [loadingTemplateRows]="9">
                <!-- Rows for X large screens -->
                <ng-container *ngIf="responsive.isXLarge()">
                    <app-alarm-table-row
                        *ngFor="
                            let alarm of alarms
                                | alarmDataSort: tHeader.sort
                                | slice: pageStart : pageEnd
                        "
                        [alarm]="alarm"
                        [disableAckButton]="shouldDisableButton(alarm)"
                        (onShowDetail)="onDetail($event)"
                    >
                    </app-alarm-table-row>
                </ng-container>
                <!-- Rows for large screens -->
                <ng-container *ngIf="responsive.isLarge()">
                    <app-alarm-table-row-compact
                        *ngFor="
                            let alarm of alarms
                                | alarmDataSort: tHeaderCompact.sort
                                | slice: pageStart : pageEnd
                        "
                        [alarm]="alarm"
                        [disableAckButton]="shouldDisableButton(alarm)"
                        [hidden]="!responsive.isLarge()"
                        (onShowDetail)="onDetail($event)"
                    >
                    </app-alarm-table-row-compact>
                </ng-container>
                <!-- Rows for rest of screens -->
                <ng-container
                    *ngIf="
                        responsive.isMedium() ||
                        responsive.isSmall() ||
                        responsive.isXSmall()
                    "
                >
                    <app-alarm-table-row-wrap
                        *ngFor="
                            let alarm of alarms
                                | alarmDataSort: tHeaderCompact.sort
                                | slice: pageStart : pageEnd
                        "
                        [alarm]="alarm"
                        [disableAckButton]="shouldDisableButton(alarm)"
                    >
                    </app-alarm-table-row-wrap>
                </ng-container>
            </app-ops-table-body>
        </div>
    </div>
    <div
        class="bottom-wrapper"
        *ngIf="!responsive.isXSmall() && !responsive.isHandsetLandscape()"
    >
        <div class="page-div">
            <app-page-list
                [pages]="pageCount"
                [(currentPage)]="currentPage"
                [displayedPageLimit]="displayedPageLimitCount()"
            >
            </app-page-list>
        </div>
        <button
            (click)="onAckAllClick()"
            class="primary ack-btn"
            [disabled]="shouldDisableButton()"
        >
            {{ "alarm.button.ack-all" | translate }}
        </button>
    </div>
</div>
<app-ops-alarm-to-top
    (onTopEmit)="onTop()"
    *ngIf="
        (responsive.isXSmall() || responsive.isHandset()) &&
        isScrollBtnVisible()
    "
></app-ops-alarm-to-top>
<app-alarm-monitoring-detail-overlay
    #alarmDetailOverlay
    [alarm]="alarmDetail"
></app-alarm-monitoring-detail-overlay>
